import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '@/styles/theme';

interface CardProps {
  $padding?: 'small' | 'medium' | 'large';
  $hoverable?: boolean;
}

export const Card = styled(motion.div)<CardProps>`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.small};
  transition: all ${theme.transitions.normal};

  padding: ${({ $padding }) => {
    switch ($padding) {
      case 'small':
        return theme.spacing.lg;
      case 'large':
        return theme.spacing.xxl;
      default:
        return theme.spacing.xl;
    }
  }};

  ${({ $hoverable }) =>
    $hoverable &&
    `
    cursor: pointer;

    &:hover {
      box-shadow: ${theme.shadows.medium};
      transform: translateY(-8px);
    }
  `}

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${({ $padding }) => {
      switch ($padding) {
        case 'small':
          return theme.spacing.md;
        case 'large':
          return theme.spacing.xl;
        default:
          return theme.spacing.lg;
      }
    }};
  }
`;
